import { render, staticRenderFns } from "./finger1.vue?vue&type=template&id=bda81774&"
import script from "./finger1.vue?vue&type=script&lang=js&"
export * from "./finger1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports